import * as React from "react";
import * as d3 from "d3";
import "./svgStyles.css";

export default class CustomAlertSpeedometer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.calculatePathValues = this.calculatePathValues.bind(this);
    this.speedoRef = React.createRef();
  }

  componentDidMount() {
    this.calculatePathValues();
  }

  calculatePathValues() {
    let assessmentPath = this.speedoRef.current;

    console.log(assessmentPath);

    let assessmentPathLength = assessmentPath.getTotalLength();

    let animate = d3.transition().duration(3000);

    d3.select(assessmentPath)
      .attr("stroke-dasharray", assessmentPathLength)
      .attr("stroke-dashoffset", assessmentPathLength)
      .transition(animate)
      .attr(
        "stroke-dashoffset",
        assessmentPathLength * (1 - this.props.value / 100)
      );
  }

  render() {
    return (
      <div className="custom-speedometer" style={{ width: "260px" }}>
        <svg viewBox="0 0 347 175.56" xmlns="http://www.w3.org/2000/svg">
          <linearGradient
            id="a"
            gradientTransform="matrix(-1 0 0 1 347 -905.87)"
            gradientUnits="userSpaceOnUse"
            x1="10.57"
            x2="336.43"
            y1="993.65"
            y2="993.65"
          >
            <stop offset="0" stop-color="#3ee9f7" />
            <stop offset=".05" stop-color="#41eaf1" />
            <stop offset=".11" stop-color="#4aebe0" />
            <stop offset=".18" stop-color="#59eec4" />
            <stop offset=".26" stop-color="#6df29d" />
            <stop offset=".35" stop-color="#87f86b" />
            <stop offset=".43" stop-color="#a7fe2e" />
            <stop offset=".45" stop-color="#acff24" />
            <stop offset=".46" stop-color="#aef924" />
            <stop offset=".52" stop-color="#c1bf28" />
            <stop offset=".59" stop-color="#d18c2b" />
            <stop offset=".65" stop-color="#df612d" />
            <stop offset=".72" stop-color="#eb3e2f" />
            <stop offset=".79" stop-color="#f42331" />
            <stop offset=".86" stop-color="#fa0f32" />
            <stop offset=".93" stop-color="#fe0433" />
            <stop offset="1" stop-color="#f03" />
          </linearGradient>
          <g fill="none">
            <path
              d="M22.57 163.06C22.57 79.91 90.14 12.5 173.5 12.5s150.93 67.41 150.93 150.56"
              stroke="#020202"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="25"
            />
            <path d="M1 173.28c0-94.45 77.23-171 172.5-171S346 78.83 346 173.28" />
            <path
            ref={this.speedoRef}
              d="M22.57 163.06C22.57 79.91 90.14 12.5 173.5 12.5s150.93 67.41 150.93 150.56"
              stroke="url(#a)"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="24"
            />
          </g>
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/CustomAlertSpeedo.Component.js